/**
 * @flow
 * @relayHash 293a52128f72eeeedec48a621ef6a668
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgCustomImageInput = {
  userId: string,
  image: string,
  clientMutationId?: ?string,
};
export type SetBackgroundCustomImageMutationVariables = {|
  input: SetUserBkgCustomImageInput
|};
export type SetBackgroundCustomImageMutationResponse = {|
  +setUserBkgCustomImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +customImage: ?string,
    |}
  |}
|};
export type SetBackgroundCustomImageMutation = {|
  variables: SetBackgroundCustomImageMutationVariables,
  response: SetBackgroundCustomImageMutationResponse,
|};
*/


/*
mutation SetBackgroundCustomImageMutation(
  $input: SetUserBkgCustomImageInput!
) {
  setUserBkgCustomImage(input: $input) {
    user {
      backgroundOption
      customImage
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgCustomImageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgCustomImageInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundOption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customImage",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetBackgroundCustomImageMutation",
  "id": null,
  "text": "mutation SetBackgroundCustomImageMutation(\n  $input: SetUserBkgCustomImageInput!\n) {\n  setUserBkgCustomImage(input: $input) {\n    user {\n      backgroundOption\n      customImage\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetBackgroundCustomImageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgCustomImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgCustomImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetBackgroundCustomImageMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgCustomImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgCustomImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c49e6f251c84d4dd6d1fc92630f7be16';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetBackgroundCustomImageMutation.graphql.js